import { PriceListOrderRuleDeleteResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePriceListOrderRuleDelete = (priceListOrderRuleId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `price-list-order-rules/${priceListOrderRuleId}`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PriceListOrderRuleDeleteResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.PriceTierOrderRules,
          priceListOrderRuleId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTierOrderRules],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderRules],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
